import { useEffect } from 'react';

export function useCanvasMovementToolToggle(input: {
  selectedIds: ReadonlySet<string>;
  toolRegistry: {
    getTool: (toolId: string) => unknown;
    activateTool: (toolId: string) => void;
    deactivateTool: (toolId: string) => void;
  };
}): void {
  const { selectedIds, toolRegistry } = input;

  // Activate/deactivate movement tool based on selection
  useEffect(() => {
    // Check if tool exists before trying to activate it
    const tool = toolRegistry.getTool('genogram-movement');
    if (!tool) return;

    if (selectedIds.size > 0) {
      toolRegistry.activateTool('genogram-movement');
    } else {
      toolRegistry.deactivateTool('genogram-movement');
    }
  }, [selectedIds, toolRegistry]);
}
